import React from "react";
import { Placeholder } from "react-bootstrap";

const Skeleton = ({
  variant = "card",
  rows = 3,
  columns = 3,
  width = "100%",
  height = "1rem",
}) => {
  if (variant === "table") {
    return (
      <table className="table">
        <thead>
          <tr>
            {Array.from({ length: columns }).map((_, index) => (
              <th key={index}>
                <Placeholder animation="glow">
                  <Placeholder xs={12} style={{ width: "80%" }} />
                </Placeholder>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: rows }).map((_, rowIndex) => (
            <tr key={rowIndex}>
              {Array.from({ length: columns }).map((_, colIndex) => (
                <td key={colIndex}>
                  <Placeholder animation="glow">
                    <Placeholder xs={12} style={{ width, height }} />
                  </Placeholder>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    );
  }

  // Default to card skeleton
  return (
    <div>
      {Array.from({ length: rows }).map((_, index) => (
        <Placeholder key={index} as="p" animation="glow">
          <Placeholder xs={12} style={{ width, height }} />
        </Placeholder>
      ))}
    </div>
  );
};

export default Skeleton;
